/* CHANGELOG 2026-11-04. Cord via Perplexity Computer.
   Approved belt/mask copy and native gallery synchronization.
   No cart, price, availability or tracking interception. Rollback: belt-mask-preview/live-rollout/rollback. */
(() => {
  function init(scope) {
    scope.querySelectorAll('.wearable-buy-area').forEach(root => {
      if (root.dataset.wearableReady) return;
      const node = root.querySelector('[data-wearable-config]');
      if (!node) return;
      const config = JSON.parse(node.textContent);
      // Preserve explicit preview URLs, not normal Intelligems treatment sessions.
      const requestedPreview = new URLSearchParams(location.search).get('preview_theme_id');
      const previewThemeId = requestedPreview === String(config.themeId)
        ? requestedPreview : (config.previewOnly ? String(config.themeId) : null);
      if (previewThemeId) root.querySelectorAll('.wearable-model[href]').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('preview_theme_id', previewThemeId);
        link.href = url.toString();
      });
      root.dataset.wearableReady = 'true';
      let lastId = null;
      function sync() {
        const input = root.querySelector(`form[id="product-form-${config.sectionId}"] input[name="id"]`);
        const id = input?.value;
        if (!id || id === lastId) return;
        lastId = id;
        root.querySelector('shopify-payment-terms')?.setAttribute('variant-id',id);
        const shipping = root.querySelector('[data-wearable-shipping]');
        if (shipping && config.shippingByVariant[id]) shipping.textContent = config.shippingByVariant[id];
        const v = config.variants.find(v => String(v.id) === String(id));
        if (!v) return;
        for (const [selector, value] of [['[data-wearable-title]',v.heading],['[data-wearable-subtitle]',v.subtitle],['[data-wearable-intro]',v.intro],['[data-wearable-coverage] strong',v.coverage],['[data-wearable-coverage] small',v.coverageDetail]]) {
          const target = root.querySelector(selector);
          if (target && value) target.textContent = value;
        }
        if (v.mediaId) {
          customElements.whenDefined('media-gallery').then(() => {
            if (lastId !== id) return;
            const gallery = root.querySelector('media-gallery');
            const mediaKey = `${config.sectionId}-${v.mediaId}`;
            if (gallery?.querySelector(`[data-media-id="${mediaKey}"]`)) gallery.setActiveMedia(mediaKey, false);
          });
        }
        if (previewThemeId) {
          const url = new URL(location.href);
          url.searchParams.set('preview_theme_id',previewThemeId);
          history.replaceState(history.state,'',url);
        }
      }
      root.addEventListener('change',e => {
        if (e.target.matches('input[name="id"]') || e.target.closest('variant-radios,variant-selects')) requestAnimationFrame(sync);
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document));
  else init(document);
  document.addEventListener('shopify:section:load',e => init(e.target));
})();
